import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, document.title, window.location.pathname);
        const role = data.active_role || (data.roles && data.roles[0]) || "customer";
        if (role === "admin" || (data.roles || []).includes("admin")) navigate("/admin");
        else if (role === "agency") navigate("/agency");
        else navigate("/dashboard");
      } catch (e) {
        navigate("/login");
      }
    };
    run();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-navy-900 text-white">
      <ShieldCheck className="w-12 h-12 text-brand animate-pulse" />
      <p className="mt-4 font-heading text-lg">Securing your session…</p>
    </div>
  );
}
